export default __webpack_public_path__ + "static/media/success.7afd7dff.png";